module.exports = __webpack_public_path__ + "assets/img3.f9017be2.jpg";